import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
export const purchaseOrderMetricsFilterSchema = z.object({
    brandId: optionalUuidString('Invalid brand selection.').nullish(),
    vendorId: optionalUuidString('Invalid vendor selection.').nullish(),
    locationGroupId: optionalUuidString('Invalid location group selection.').nullish(),
});
//# sourceMappingURL=metrics-filter.js.map